var app = app ||  {};
app.staticdatatable = app.staticdatatable || {};

;(function(namespace, $){

  function staticDataTable(el_id) {

      $('#' + el_id).DataTable({
        "pageLength": 25,
        "lengthMenu": [25, 50, 100],
        language: {
            paginate: {
              first:    '«',
              previous: '‹',
              next:     '›',
              last:     '»'
            },
            aria: {
              paginate: {
                  first:    'Primeira',
                  previous: 'Anterior',
                  next:     'Próxima',
                  last:     'ùltima'
              }
            },
          "search": "Buscar:",
          "sProcessing": '<img src="' + loading_img + '" alt=""> Carregando...',
          searchPlaceholder: "buscar...",
          "info": "Mostrando _START_ a _END_ de _TOTAL_ resultados",
          "lengthMenu": "Exibir _MENU_ resultados",
          "zeroRecords": "Nenhum resultado",
          "infoEmpty": "",
          "infoFiltered": ""
        }
      });
    }

    namespace.staticDataTable = staticDataTable;

})(app.staticdatatable, jQuery);

